import { REGIONS_DATA } from '@/data'
import link from './link'
import { getLanguageQueryString } from '@/data/sanity/utils-language'

export const fields = `
  blogPostData {
    ${getLanguageQueryString([
      'publishedDate',
      {
        name: 'blogCategory',
        dereference: true,
        fields: `
        title, 
        slug
      `,
      },
    ])}
  },
  ${Object.values(REGIONS_DATA)
    .map(({ code: regionCode }) => {
      return `
      $language == "${regionCode}" => {
        "richTextContent": richTextContent.${regionCode}RichTextContent[] {
          _key,
          _type,
          children[] {
            ...,
            _type == "link" => {
              ${link.fields}
            },
          },
          style,
          listItem,
          level
        }
      }
    `
    })
    .join(',')}
`

export const fragment = (name = 'blogPost') => `${name}{${fields}}`

const exported = {
  fields,
  fragment,
}

export default exported
